import { render, staticRenderFns } from "./ot-document-associations-list.vue?vue&type=template&id=0fe6a68c&scoped=true&"
import script from "./ot-document-associations-list.vue?vue&type=script&lang=ts&"
export * from "./ot-document-associations-list.vue?vue&type=script&lang=ts&"
import style0 from "./ot-document-associations-list.vue?vue&type=style&index=0&id=0fe6a68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6a68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
